import { StyledSlide } from './IterationSummary.style';
import IterationSummary from './IterationSummary';
import { Card } from '@linearb/linui-common';

const IterationSummarySlide = ({
  isIterationSummaryOpen,
  iterationSummary
}) => {
  return (
    <StyledSlide
      direction='left'
      in={isIterationSummaryOpen}
      timeout={750}
      mountOnEnter
      unmountOnExit
    >
      <Card elevation={2}>
        <IterationSummary iterationSummary={iterationSummary} />
      </Card>
    </StyledSlide>
  );
};

export default IterationSummarySlide;
